module.exports = __webpack_public_path__ + "img/2537.aa395c0b.png";